import 'css/src/components/common/Lumen5Icon';

import React from 'react';

import { COLOR_L5_PRIMARY_800 } from 'js/src/libs/consts';

type Props = {
    fillColor?: string;
};

const Lumen5Icon = React.memo(function Lumen5Icon({ fillColor = COLOR_L5_PRIMARY_800 }: Props) {
    return (
        <div className="lumen5-icon">
            <svg
                className="left-shape"
                width="19"
                height="28"
                viewBox="0 0 19 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.3375 20.7108C12.3974 20.4701 12.3375 20.1692 12.1577 19.9886L8.0218 15.8362C7.60222 15.4149 7.60222 14.7529 8.0218 14.3317L18.6911 3.61953C18.811 3.49917 18.811 3.25845 18.6911 3.13809L17.5523 1.99466C16.1736 0.610505 13.8959 0.610505 12.4574 1.99466L1.06876 13.429C-0.309865 14.8131 -0.309865 17.1 1.06876 18.5443L9.64018 27.1501C9.82 27.3306 10.1197 27.2705 10.2396 27.0297L12.3375 20.7108Z"
                    fill={fillColor}
                />
            </svg>
            <svg
                className="right-shape"
                width="20"
                height="27"
                viewBox="0 0 20 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.77009 0.943469L6.67219 7.20224C6.61225 7.44296 6.67219 7.74387 6.85201 7.92441L10.9879 12.0769C11.4074 12.4981 11.4074 13.1601 10.9879 13.5814L0.378484 24.2935C0.258604 24.4139 0.258604 24.6546 0.378484 24.7749L1.51734 25.9184C2.89597 27.3025 5.17369 27.3025 6.61225 25.9184L18.0009 14.4841C19.3795 13.0999 19.3795 10.8131 18.0009 9.36874L9.36949 0.823109C9.18967 0.582387 8.88997 0.702747 8.77009 0.943469Z"
                    fill={fillColor}
                />
            </svg>
        </div>
    );
});

export default Lumen5Icon;
